import { Link } from "react-router-dom";
import type { MangaWork } from "@/mocks/manga";

interface MangaCardProps {
  work: MangaWork;
  rank?: number;
}

export default function MangaCard({ work, rank }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${work.id}`}
      title={`${work.title}漫画免费阅读`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300/60"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title}漫画封面`}
          title={`${work.title}漫画免费阅读`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-[11px] font-bold text-background-50 ${
            work.status === "已完结" ? "bg-secondary-500" : "bg-accent-500"
          }`}
        >
          {work.status}
        </span>
        {rank !== undefined && rank <= 3 && (
          <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 font-comic text-sm text-background-50">
            {rank}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-black/70 via-black/40 to-transparent p-3 pt-8 transition-transform duration-300 group-hover:translate-y-0">
          <p className="flex items-center gap-1 text-xs font-bold text-background-50">
            <i className="ri-book-open-line"></i>立即阅读
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-1 p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {work.title}
        </h3>
        <p className="truncate text-xs text-foreground-600">{work.latestChapter}</p>
        <div className="flex items-center justify-between gap-2">
          <span className="whitespace-nowrap rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900">
            {work.categoryName}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap text-xs font-bold text-accent-700">
            <i className="ri-star-fill text-accent-500"></i>
            {work.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}